/**
 * Финальная таблица итогов сессии (GET /api/sessions/{id}/results): сводка по
 * сессии + лидерборд участников (очки, верно/ответлено, среднее время ответа).
 */
import { useTranslation } from 'react-i18next';
import type { SessionResults } from '../api';

export interface ResultsBoardProps {
  results: SessionResults;
}

export function ResultsBoard({ results }: ResultsBoardProps): JSX.Element {
  const { t } = useTranslation();
  const players = [...results.players].sort(
    (a, b) => b.score - a.score || b.correct - a.correct || a.avgMs - b.avgMs,
  );
  return (
    <div className="results">
      <div className="results-summary">
        <span>
          {t('results.participants')} <strong>{results.playerCount}</strong>
        </span>
        <span>
          {t('results.answers')} <strong>{results.answerCount}</strong>
        </span>
        <span>
          {t('results.correct')} <strong>{results.correctCount}</strong>
        </span>
      </div>
      {players.length === 0 ? (
        <p className="muted">{t('results.empty')}</p>
      ) : (
        <table className="results-table">
          <thead>
            <tr>
              <th>#</th>
              <th>{t('results.colPlayer')}</th>
              <th>{t('results.colScore')}</th>
              <th>{t('results.colCorrect')}</th>
              <th>{t('results.colAvgTime')}</th>
            </tr>
          </thead>
          <tbody>
            {players.map((p, i) => (
              <tr key={p.playerId}>
                <td>{i + 1}</td>
                <td>{p.nickname}</td>
                <td>{p.score}</td>
                <td>
                  {p.correct}/{p.answered}
                </td>
                <td>
                  {Math.round(p.avgMs)} {t('results.msUnit')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
